import L from "leaflet";
import { Controller } from "stimulus";

const markerIcon = L.icon({
  iconUrl: "/icons/marker-icon-2x.png",
  iconSize: [25, 41],
});

export default class extends Controller {
  static values = { latitude: Number, longitude: Number };

  connect() {
    const location = [this.latitudeValue, this.longitudeValue];
    const map = L.map(this.element, { zoomControl: false, attributionControl: false }).setView(
      location,
      8
    );
    L.tileLayer(
      "https://api.maptiler.com/maps/basic-v2/{z}/{x}/{y}.png?key=Mo18Hv7gYYAKwx9mN7wz"
    ).addTo(map);
    L.control
      .zoom({
        position: "bottomright",
      })
      .addTo(map);
    L.marker(location, { icon: markerIcon }).addTo(map);
  }
}
